export const sliceTitle = (title) => {
  const squareBracketStart = title.indexOf("[");
  const squareBracketEnd = title.indexOf("]");

  if (squareBracketStart !== -1 && squareBracketEnd !== -1) {
    return title.slice(0, squareBracketStart);
  }
  return title;
}
